module.exports = __webpack_public_path__ + "img/blue_167.924348e9.png";